module.exports = __webpack_public_path__ + "img/wireless-bluetooth-4.dae8f9d2.png";